<cm-routed-dialog #overlayDialog [dialogSize]="DialogSize.Large" [dialogScroll]="false" [needsConfirmationToClose]="$isEdited()">
    <ng-container cm-overlay-content>
        @if (($showSpinner() || !$isInitialFrameDrawn()) && !$initialLoadError()) {
            <div class="cm-image-state-overlay">
                <mat-progress-spinner mode="indeterminate" [diameter]="48" [strokeWidth]="6" color="primary"></mat-progress-spinner>
            </div>
        }
        <div class="cm-main-card">
            <div class="cm-section-label">
                <button class="cm-back-icon" (click)="navigateBack()" matTooltip="Back to material">
                    <i class="far fa-chevron-left"></i>
                </button>
                @if (dataService.$revision(); as revision) {
                    <div class="cm-revision-tabs">
                        @for (descriptor of revision.sortedTextureSetRevisionDescriptors | slice: 0 : 5; track descriptor.id) {
                            <div
                                (click)="revision.textureSetRevision.id !== descriptor.id ? setTextureSetRevision(descriptor.id) : null"
                                class="cm-revision-tab"
                                [class.cm-revision-tab-active]="revision.textureSetRevision.id === descriptor.id"
                            >
                                <div class="cm-revision-title">
                                    {{ $getRevisionTitle()(descriptor, revision.sortedTextureSetRevisionDescriptors.length - $index) }}
                                </div>
                                @if (revision.textureSetRevision.id === descriptor.id) {
                                    <div class="cm-revision-actions">
                                        <i class="far fa-ellipsis-v cm-revision-menu" [matMenuTriggerFor]="moreMenu"></i>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    @if (revision.sortedTextureSetRevisionDescriptors.length >= 5) {
                        <i class="far fa-chevron-down cm-revision-tabs-dropdown" [matMenuTriggerFor]="revisionMenu"></i>
                        <mat-menu #revisionMenu="matMenu" yPosition="below">
                            @for (descriptor of revision.sortedTextureSetRevisionDescriptors | slice: 5; track descriptor.id) {
                                <button
                                    class="cm-revision-menu-item"
                                    [class.cm-revision-menu-item-active]="revision.textureSetRevision.id === descriptor.id"
                                    mat-menu-item
                                    (click)="setTextureSetRevision(descriptor.id)"
                                >
                                    {{ $getRevisionTitle()(descriptor, revision.sortedTextureSetRevisionDescriptors.length - $index - 5) }}
                                </button>
                            }
                        </mat-menu>
                    }
                }

                <mat-menu #moreMenu="matMenu">
                    <button mat-menu-item (click)="actions.renameRevision()">Rename</button>
                    <button mat-menu-item (click)="actions.adjustSize()">Adjust size</button>
                    <mat-divider></mat-divider>
                    @if ($hasOperators()) {
                        <button mat-menu-item [disabled]="$isEdited()" (click)="copyCurrentRevision(true)">Copy revision with operators</button>
                        <button mat-menu-item [disabled]="$isEdited()" (click)="copyCurrentRevision(false)">Copy revision without operators</button>
                    } @else {
                        <button mat-menu-item [disabled]="$isEdited() || dataService.$isProcessingEdits()" (click)="copyCurrentRevision(false)">
                            Copy revision
                        </button>
                    }
                    <mat-divider></mat-divider>
                    <button mat-menu-item [disabled]="dataService.$isInUse()" (click)="deleteCurrentRevision()">Delete revision</button>
                    <!--                    @if (enableDebugFeatures) {-->
                    <!--                        <mat-divider></mat-divider>-->
                    <!--                        <button mat-menu-item (click)="downloadGraph()">Download image op graph</button>-->
                    <!--                    }-->
                </mat-menu>
            </div>
            <div class="cm-left-panel-container">
                @if (dataService.$processingJobId(); as jobId) {
                    <cm-job-task-progress [jobId]="jobId"></cm-job-task-progress>
                }

                @if ($initialLoadError(); as loadError) {
                    <cm-hint [hintType]="HintTypes.Warning">
                        <ng-container cm-text>This texture revision could not be loaded: {{ loadError.message }}</ng-container>
                    </cm-hint>
                } @else if (!dataService.$hasValidResolutions()) {
                    <cm-hint [hintType]="HintTypes.Warning">
                        <ng-container cm-text> The maps in this revision do not permit editing because they are of inconsistent resolution.</ng-container>
                    </cm-hint>
                } @else if (!dataService.$hasValidRatio()) {
                    <cm-hint [hintType]="HintTypes.Warning">
                        <ng-container cm-text>
                            The maps in this revision do not permit editing because they contain non-square pixel ratios.<br /><br /><b
                                ><a href="javascript:void(0)" (click)="actions.adjustSize()">Click here to adjust the physical size accordingly. </a></b
                            >
                        </ng-container>
                    </cm-hint>
                }
                @if (dataService.$isInUse()) {
                    <cm-hint>
                        <ng-container cm-text> This revision is used by a material and can not be modified or removed.</ng-container>
                    </cm-hint>
                } @else if (!dataService.$canEditDisplacementMap()) {
                    <cm-hint>
                        <ng-container cm-text>
                            The displacement map can not be edited because it is auto-generated from the normal map. Only the final result will be displayed.
                        </ng-container>
                    </cm-hint>
                }

                <div class="cm-texture-revision-group">
                    <cm-texture-selector
                        #textureSelector
                        [textureSetRevision]="dataService.$revision()?.textureSetRevision"
                        [availableTextureTypes]="dataService.$revision()?.availableTextureTypes ?? []"
                        [selectedTextureType]="dataService.$selectedTextureType() ?? TextureType.Diffuse"
                        (selectedTextureTypeChange)="setTextureType($event)"
                    >
                    </cm-texture-selector>
                    <cm-tiling-info-panel
                        [createdByName]="dataService.$revision()?.textureSetRevision?.createdBy?.name"
                        [createdAt]="dataService.$revision()?.textureSetRevision?.createdAt"
                        [updatedByName]="dataService.$revision()?.textureSetRevision?.updatedBy?.name"
                        [updatedAt]="dataService.$revision()?.textureSetRevision?.updatedAt ?? undefined"
                        [imageColorSpace]="dataService.$textureTypeData()?.resultDataObject?.imageColorSpace ?? undefined"
                        [pxPerCm]="dataService.$pxPerCm()"
                        [resultResolution]="$resultResolution()"
                        [resultFileSize]="dataService.$textureTypeData()?.resultDataObject?.size"
                        [displacement]="dataService.$revision()?.textureSetRevision?.displacement ?? undefined"
                    ></cm-tiling-info-panel>
                </div>
                @if (dataService.$isLegacyUnsupportedEdit()) {
                    <cm-hint [hintType]="HintTypes.Warning">
                        <ng-container cm-text>
                            This is a legacy edit which can no longer be edited.<br /><br />
                            You can start a new revision based on this revision's original source maps to begin new edits.<br /><br />
                            <b><a href="javascript:void(0)" (click)="copyCurrentRevision(false)">Copy to new revision</a></b>
                        </ng-container>
                    </cm-hint>
                } @else if ($hasOperatorStack()) {
                    <cm-operators-panel
                        [disabledEdits]="!$canEdit()"
                        [operatorStack]="$operatorStackOrThrow()"
                        (importOperators)="importOperatorsFromRevision()"
                    >
                        <ng-container cm-extra-content>
                            @if ($isEdited()) {
                                @if (!$isOperatorStackValid()) {
                                    <cm-hint [hintType]="HintTypes.Warning">
                                        <ng-container cm-text>
                                            @for (msg of $operatorValidationMessages(); track msg) {
                                                {{ msg }}
                                            }
                                        </ng-container>
                                    </cm-hint>
                                }
                                <div class="cm-submission-buttons">
                                    <cm-button (click)="save()" class="cm-save" [class.cm-active]="$canSubmit()" [disabled]="!$canSubmit()">
                                        <ng-container cm-left-icon>
                                            <i class="far fa-play"></i>
                                        </ng-container>
                                        <ng-container cm-text> Submit changes</ng-container>
                                    </cm-button>
                                    <cm-button (click)="discardChanges()">
                                        <ng-container cm-left-icon>
                                            <i class="far fa-trash"></i>
                                        </ng-container>
                                        <ng-container cm-text> Discard changes</ng-container>
                                    </cm-button>
                                </div>
                            }
                        </ng-container>
                    </cm-operators-panel>
                }
            </div>
            <div class="cm-inspector-area">
                <cm-operator-inspector
                    [disabledEdits]="!$canEdit()"
                    [textureEditCanvas]="$tilingCanvas()"
                    [availableTextureTypes]="dataService.$availableTextureTypesForOperators()"
                    [operator]="$inspectedOperator()"
                >
                </cm-operator-inspector>
            </div>
            <div class="cm-viewer-section">
                <cm-tiling-canvas
                    #tilingCanvasRef
                    [onAboutToBeDestroyed]="disposeOperatorStack"
                    (frameDrawn)="onFrameDrawn()"
                    (loadError)="onCanvasLoadError($event)"
                >
                </cm-tiling-canvas>
                <cm-tiling-controls
                    #tilingControls
                    [dataObject]="dataService.$textureTypeData()?.resultDataObject"
                    [canDownload]="dataService.$revision() !== undefined && !dataService.$isProcessingEdits() && !$isEdited()"
                    (zoomClick)="$tilingCanvas().zoomToPhysicalPixels()"
                    [gridActive]="$tilingCanvas().$gridActive()"
                    (gridClick)="$tilingCanvas().toggleGrid()"
                    [brightnessBoostActive]="$tilingCanvas().$brightnessBoostActive()"
                    (brightnessBoostToggle)="$tilingCanvas().toggleBrightnessBoost()"
                ></cm-tiling-controls>
            </div>
        </div>
    </ng-container>
</cm-routed-dialog>
